module.exports = __webpack_public_path__ + "img/aspnet.aa0ef96d.png";